/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useContext, useEffect, useState } from "react";
import FilieraContext from "../../contexts/filieraContext";
import { useAccount, useMsal } from "@azure/msal-react";
import { PermissionsApi } from "../../data/apis/PermissionsApi";
import { apiConfiguration } from "../../apiConfig";
import { LoadPanel } from "devextreme-react/load-panel";

export default function CarichiPage() {
  const { currentFiliera } = useContext(FilieraContext);
  const [link, setLink] = useState<string>("");
  const [loading, setLoading] = useState(true);

  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  useEffect(() => {
    const load = async () => {
      if (!currentFiliera) {
        setLoading(false);
        return;
      }

      try {
        const api = new PermissionsApi(apiConfiguration);

        // 🔹 1. Recupero tutti i permessi di tipo Filiera
        const perms = await api.getFilierePermissions();

        // 🔹 2. Filtra SOLO i permessi Carichi
        const carichiPerms = perms.filter(p =>
          p.filieraPermissionId?.includes("Filiera/BI/Carichi")
        );

        // 🔹 3. Determina il suffisso della filiera: /01 /02 /03
        const suffix = currentFiliera.Id === 1 
          ? "/01"
          : currentFiliera.Id === 2
          ? "/02"
          : "/03";

        // 🔹 4. Trova il permesso corrispondente
        const perm = carichiPerms.find(p =>
          p.filieraPermissionId?.endsWith(suffix)
        );

        if (!perm) {
          // La terza filiera o filiere senza permessi → nessun accesso
          setLink("");
          setLoading(false);
          return;
        }

        // 🔹 5. Determina il ruolo dal permissionId
        let role = "";
        if (perm.filieraPermissionId?.includes("/Amministrativo/")) role = "admin";
        else if (perm.filieraPermissionId?.includes("/Gestione/")) role = "gestione";
        else if (perm.filieraPermissionId?.includes("/Tecnico/")) role = "tecnico";

        // 🔹 6. Switch-case sulla filiera
        switch (currentFiliera.Id) {
          case 1: // FILIERA AGRICOLA /01
            if (role === "admin") {
              setLink("https://app.powerbi.com/reportEmbed?reportId=4fd6df77-1631-4d56-af27-5060c85cc561&autoAuth=true&ctid=9a6bb95e-2985-4dfd-b3bf-18638a129013&pageName=ReportSectionc221919513f422bd3b0a");
            } else if (role === "gestione") {
              setLink("https://app.powerbi.com/reportEmbed?reportId=a98b2c5f-d462-4154-8fc6-8da659150f60&autoAuth=true&ctid=9a6bb95e-2985-4dfd-b3bf-18638a129013&pageName=ReportSectionc221919513f422bd3b0a");
            } else if (role === "tecnico") {
              setLink("https://app.powerbi.com/reportEmbed?reportId=0fd62d51-da98-445b-8d6c-8c3988022c7c&autoAuth=true&ctid=9a6bb95e-2985-4dfd-b3bf-18638a129013&pageName=ReportSectionc221919513f422bd3b0a");
            } else {
              setLink("");
            }
            break;

          case 2: // FILIERA CASCINA /02
            if (role === "admin") {
              setLink("https://app.powerbi.com/reportEmbed?reportId=4fd6df77-1631-4d56-af27-5060c85cc561&autoAuth=true&ctid=9a6bb95e-2985-4dfd-b3bf-18638a129013&pageName=ReportSection47311b9d07dbe9ffae91");
            } else if (role === "gestione") {
              setLink("https://app.powerbi.com/reportEmbed?reportId=a98b2c5f-d462-4154-8fc6-8da659150f60&autoAuth=true&ctid=9a6bb95e-2985-4dfd-b3bf-18638a129013&pageName=ReportSection47311b9d07dbe9ffae91");
            } else if (role === "tecnico") {
              setLink("https://app.powerbi.com/reportEmbed?reportId=0fd62d51-da98-445b-8d6c-8c3988022c7c&autoAuth=true&ctid=9a6bb95e-2985-4dfd-b3bf-18638a129013&pageName=ReportSection47311b9d07dbe9ffae91");
            } else {
              setLink("");
            }
            break;

          case 3: // FILIERA 3 → nessun accesso
          default:
            setLink("");
            break;
        }

      } catch (e) {
        console.error("Errore Carichi:", e);
        setLink("");
      }

      setLoading(false);
    };

    load();
  }, [currentFiliera]);

  if (loading) {
    return <LoadPanel visible={true} position={{ of: ".content" }} />;
  }

  return (
    <React.Fragment>
      {link !== "" && (
        <iframe
          src={link}
          style={{
            display: "block",
            background: "#000",
            border: "none",
            height: "85vh",
            width: "100%",
          }}
          allowFullScreen
        />
      )}

      {link === "" && <label>Nessun report per questa filiera</label>}
    </React.Fragment>
  );
}
